/**
 * @generated SignedSource<<50ce56d6f6bd77ed648515cc3a4b951f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type Language = "AMERICAN_SIGN_LANGUAGE" | "ARABIC" | "CANTONESE" | "DUTCH" | "ENGLISH" | "FRENCH" | "GERMAN" | "HINDI" | "ITALIAN" | "JAPANESE" | "KOREAN" | "MANDARIN" | "PORTUGUESE" | "RUSSIAN" | "SPANISH" | "THAI" | "TURKISH" | "UKRAINIAN" | "%future added value";
export type LanguageProficiencyLevel = "FLUENT" | "LIMITED_WORKING" | "PROFESSIONAL_WORKING" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type Languages_userProfile$data = {
  readonly visitorCanEdit: boolean;
  readonly workPreferences: {
    readonly languages: ReadonlyArray<{
      readonly languageName: Language;
      readonly proficiency: LanguageProficiencyLevel;
    }>;
  };
  readonly " $fragmentType": "Languages_userProfile";
};
export type Languages_userProfile$key = {
  readonly " $data"?: Languages_userProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"Languages_userProfile">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Languages_userProfile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "WorkPreferences",
      "kind": "LinkedField",
      "name": "workPreferences",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "LanguageProficiency",
          "kind": "LinkedField",
          "name": "languages",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "languageName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "proficiency",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitorCanEdit",
      "storageKey": null
    }
  ],
  "type": "UserProfile",
  "abstractKey": null
};

(node as any).hash = "a9d5c424769b1460c1e0c3dd7aa64359";

export default node;
